<template>
  <div class="BaseLogo relative gap-2 flex items-center">
    <img
      ref="image"
      :class="{
        'w-8 h-[35px]': isSmall,
        'w-[60px] h-[66px]': isBig
      }"
      src="/images/logo-sm.webp"
    />

    <span v-if="isLabel" class="text-lg font-bold">Capino</span>
  </div>
</template>

<script>
export default {
  name: 'BaseLogo',

  props: {
    isBig: { type: Boolean, default: false },
    isLabel: { type: Boolean, default: true }
  },

  computed: {
    isSmall() {
      return !this.isBig
    }
  }
}
</script>
